import { ArrowRightOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { Grid, Form, theme, Typography, Card, Button, List } from "antd";
import BrandColors from "@brand-colors";
import { useUiState } from "helpers/useUiState";
import { useNavigate } from "react-router-dom";
import { useMemberActivityListSrv } from "./useMemberActivityListSrv";
import { t } from "i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useSelector } from "react-redux";
import whitelabelConfig from "@whitelabel-config";

const MemberActivityList = ({}) => {
  useEffect(() => {}, []);
  const { isAppLoading } = useUiState();
  const { useToken } = theme;
  const { useBreakpoint } = Grid;
  const { token } = useToken();
  const screens = useBreakpoint();
  const [surveyList, setsurveyList] = useState<any>(null);
  const [isHover, setIsHover] = useState(false);
  const { httpGetMemberActivities, mergeSurveyJson } =
    useMemberActivityListSrv();
  const navigate = useNavigate();

  const uiState = useSelector((state: any) => state.portal.uiState);
  const preferredLanguage = useSelector(
    (state: any) => state.portal.uiState.Language
  );
  console.log(preferredLanguage, "preferredLanguage");
  const [isRightAlign, setIsRightAlign] = useState(false);
 const [surveyLangConfirmed, setSurveyLangConfirmed] = useState(false);
  const styles = {
    container: {
      margin: "0 auto",
      maxWidth: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },

    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
    },
    mainheader: {
      height: "80px",
      padding: "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
      borderTop: "1px solid #cccccc",
    },

    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
    },

    button: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      textTransform: "uppercase",
      fontWeight: "500",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: token.colorBgContainer,
        color: BrandColors.BUTTON_BG,
      },
    },
  };
console.log("surveyLangConfirmed..", surveyLangConfirmed);
  useEffect(() => {
    try {
      if (
        whitelabelConfig.uiSettings.rightAlignedLanguage.includes(
          preferredLanguage
        ) === true
      ) {
        setIsRightAlign(true);
      } else {
        setIsRightAlign(false);
      }
    } catch (e) {
      console.log("Error", e);
      handleErrorNavigation(e, navigate, t);
    }
  }, [whitelabelConfig, preferredLanguage]);

  useEffect(() => {
    isAppLoading(true);
    httpGetMemberActivities()
      ?.then((res) => {
        isAppLoading(false);
        console.log("res.data", res.data);
        console.log("res.data", res.data[0].LanguageConfirmed);
        // Save before navigation
        sessionStorage.setItem(
          "languageConfirmed",
          res.data[0].LanguageConfirmed
        );

        // On next page
        const languageConfirmed =
          sessionStorage.getItem("languageConfirmed") === "true";

        let rueBasedActivities = res.data.filter(function (item: any) {
          return item.IsRuleBasedSurvey == true;
        });
        console.log("rueBasedActivities", rueBasedActivities);
        setsurveyList(rueBasedActivities);
        setSurveyLangConfirmed(res.data[0].LanguageConfirmed);
      })
      .catch((e) => {
        isAppLoading(false);
        // handleErrorNavigation(e, navigate, t);
      });
  }, []);
  const mergeAndProceedSurvey = async (item: any) => {
    try {
      const data = await mergeSurveyJson(item);
      data["PatientID"] = item.PatientID;
      data["surveyID"] = item.PatientActivityID;
      data["PatientActivityName"] = item.PatientActivityName;
      data["IsRuleBasedSurvey"] = item.IsRuleBasedSurvey;
      data["StartDate"] = item.StartDate;
      data["SurveyUrl"] = item.SurveyUrl;
      data["IsPartialSaveEnabled"] = item.IsPartialSaveEnabled;
      data["TranslationGroupID"] = item.TranslationGroupID;
      data["PatientActivityDetailID"] = item.PatientActivityDetailID;
      data["PreferredLanguage"] = item.PreferredLanguage;
      if (data.surveyPages && Array.isArray(data.surveyPages)) {
        let detailIndex = 0;

        data.surveyPages.forEach((page) => {
          if (page.surveyQuestions && Array.isArray(page.surveyQuestions)) {
            page.surveyQuestions.forEach((question) => {
              if (
                item.PatientActivityDetails &&
                item.PatientActivityDetails[detailIndex]
              ) {
                const detail = item.PatientActivityDetails[detailIndex];
                question["PatientActivityDetailID"] =
                  detail.PatientActivityDetailID;
                question["QuestionNumber"] = detail.QuestionNumber;
                question["Response"] = detail.Response;

                detailIndex++;
              }
            });
          }
        });
        console.log("data***",data)
      }
      const agreementText = data.confirmationText;
      const renderHtml = data.surveyConfirmations[0]?.renderHtml;
      const languageConfirmed = data.LanguageConfirmed;
      navigate("/member/memberportalagreement", {
        state: {
          rawSurveyData: data,
          agreementText: agreementText,
          renderHtml: renderHtml,
          languageConfirmed: surveyLangConfirmed,
        },
      });
    } catch (error) {
      console.log("download JSON failed");
      console.log(error);
    }
  };
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const handleSurveyList = (survey: any) => {
    if (survey.IsRuleBasedSurvey == true) {
      mergeAndProceedSurvey(survey);
    } else {
      console.log("Not RuleBased Survey");
    }
  };
  console.log("surveyList", surveyList);
  return (
    <>
      <div className="row page-wrapper justify-content-md-center mx-0 surveylist-wrapper">
        <div className="col-md-12 col-sm-12">
          <Card
            className="home-widget-card surveylist-card hls-container"
            style={{ borderRadius: "0" }}
          >
            <div className="card-body">
              {surveyList && surveyList.length > 0 ? (
                <List
                  bordered
                  dataSource={surveyList !== null ? surveyList : ""}
                  renderItem={(item: any) => (
                    <List.Item>
                      <Typography.Text
                        style={{
                          fontSize: screens.md ? "16px" : "14px",
                          fontWeight: "600",
                        }}
                      >
                        {item.PatientActivityName}
                      </Typography.Text>
                      <Form.Item style={{ marginBottom: "0" }}>
                        <Button
                          block={true}
                          type="primary"
                          style={styles.button}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                          onClick={(e) => {
                            handleSurveyList(item);
                          }}
                        >
                          <ArrowRightOutlined />
                        </Button>
                      </Form.Item>
                    </List.Item>
                  )}
                />
              ) : (
                <div style={{ textAlign: isRightAlign ? "right" : "left" }}>
                  {t("SURVEY_PAGE.NO_RECORDS")}
                </div>
              )}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};
export default MemberActivityList;
